import { render } from "./RecoveryForm.vue?vue&type=template&id=1eb3a83c&scoped=true"
import script from "./RecoveryForm.vue?vue&type=script&lang=js"
export * from "./RecoveryForm.vue?vue&type=script&lang=js"

import "./RecoveryForm.vue?vue&type=style&index=0&id=1eb3a83c&scoped=true&lang=css"

import exportComponent from "/home/andre_merino/aihuk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eb3a83c"]])

export default __exports__